import { MAP } from '@/config';
import { useT } from '@/i18n/LocaleProvider';

import { categoryColor } from './colors';

export type CategoryFilterProps = {
  categories: string[];
  active: Set<string> | null;
  onChange: (active: Set<string> | null) => void;
};

export function CategoryFilter({ categories, active, onChange }: CategoryFilterProps) {
  const t = useT();

  if (categories.length === 0) return null;

  function toggle(cat: string) {
    if (active === null) {
      const next = new Set(categories.filter((c) => c !== cat));
      onChange(next.size === categories.length ? null : next);
    } else {
      const next = new Set(active);
      if (next.has(cat)) {
        next.delete(cat);
      } else {
        next.add(cat);
      }
      onChange(next.size === categories.length ? null : next);
    }
  }

  return (
    <fieldset className="category-filter" aria-label={t('map_filter_label')}>
      <button
        type="button"
        onClick={() => onChange(null)}
        className={`category-filter-btn${active === null ? ' category-filter-btn--active' : ''}`}
        aria-pressed={active === null}
      >
        {t('map_filter_all')}
      </button>
      {categories.map((cat) => {
        const color = categoryColor(cat, MAP.palette);
        const isActive = active === null || active.has(cat);
        return (
          <button
            key={cat}
            type="button"
            onClick={() => toggle(cat)}
            className={`category-filter-btn${isActive ? ' category-filter-btn--active' : ''}`}
            aria-pressed={isActive}
          >
            {color && (
              <span
                className="category-filter-swatch"
                style={{ backgroundColor: color }}
                aria-hidden="true"
              />
            )}
            {cat}
          </button>
        );
      })}
    </fieldset>
  );
}
